<template>
  <div>
    <v-card elevation="0">
      <v-card-text>
        <Announcement />
        <v-row>
          <v-col cols="4">
            <Contact />
          </v-col>
          <v-col cols="8">
            <AddressWarning /><br />
            <ComingDeadline />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>

import Announcement from "../../../components/Applicants/Home/Announcement.vue"
import Contact from "../../../components/Applicants/Home/Contact.vue"
import ComingDeadline from "../../../components/Applicants/Home/UpcomingDeadlines.vue"
import AddressWarning from "../../../components/Applicants/Home/AddressWarning.vue"

export default {
  components: {
    Announcement,
    Contact,
    ComingDeadline,
    AddressWarning
  },
  data() {
    return {
    };
  }
};
</script>